export interface NavigationMenuItem {
    translationKey?: string;
    id?: string;
    isDefault?: boolean;
    isHidden?: boolean;
    positionOnNavBar?: NavigationMenuPosition;
    parentMenu?: NavigationMenuItem;
    staticSubMenus?: NavigationMenuItem[];
    hasDynamicSubMenu?: boolean;
    externalLink?: string;
    materialIcon?: string;
    isStaticSubmenuVisible?: boolean;
    chunkedSubMenus?: NavigationMenuItem[][];
}

export interface DynamicSubMenuItem {
    title?: string;
    id?: string;
    isVisible?: boolean;
    parentMenu?: NavigationMenuItem;
}

export enum NavigationMenuPosition {
    left, right
}
